// PartnerFormThree.jsx
import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import { UserPartner } from "../../../../api";
import { useAuth } from "../../../../hooks";
import {
  initialValuesThree,
  validationSchemaTrhee,
} from "./PartnerFormThree.form";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

const partnerUserCntroller = new UserPartner();

export function PartnerFormThree(props) {
  const {
    formData,
    prevStep,
    user,
    onReload,
    onClose,
    envioDatacontact = false, // true por defecto si no se define
  } = props;

  const { accessToken } = useAuth();
  const { t } = useTranslation(["partners", "common"]);

  const formik = useFormik({
    initialValues: initialValuesThree(user.user, formData),
    validationSchema: validationSchemaTrhee(t),
    validateOnChange: true, // <--- Activado
    validateOnBlur: true, // <--- Activado
    onSubmit: async (values) => {
      try {
        const finalData = {
          ...formData,
          ...values,
        };

        // Aquí aplicamos la lógica:
        // Si envioDatacontact === false, eliminamos contactPersons del finalData
        if (!envioDatacontact) {
          delete finalData.contactPersons;
        }

        await partnerUserCntroller.createUser(
          accessToken,
          finalData,
          user.user,
        );
        onReload();
        onClose();
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: "top-center",
          autoClose: false,
          closeOnClick: true,
        });
      }
    },
  });
  console.log("ERRORES:", formik.errors);
  return (
    <>
      <ToastContainer />
      <Form onSubmit={formik.handleSubmit}>
        {/* Sólo mostramos los campos si envioDatacontact es true */}
        {envioDatacontact && (
          <>
            <Form.Input
              type="text"
              name="contactPersons[0].name"
              placeholder={t("partners:form.contactNamePlaceholder")}
              onChange={formik.handleChange}
              value={formik.values.contactPersons[0].name}
              error={
                formik.errors.contactPersons?.[0]?.name
                  ? {
                      content: formik.errors.contactPersons[0].name,
                      pointing: "above",
                    }
                  : null
              }
            />
            <Form.Input
              type="text"
              name="contactPersons[0].phone"
              placeholder={t("partners:form.contactPhonePlaceholder")}
              onChange={formik.handleChange}
              value={formik.values.contactPersons[0].phone}
              error={
                formik.errors.contactPersons?.[0]?.phone
                  ? {
                      content: formik.errors.contactPersons[0].phone,
                      pointing: "above",
                    }
                  : null
              }
            />
            <Form.Input
              type="email"
              name="contactPersons[0].email"
              placeholder={t("partners:form.contactEmailPlaceholder")}
              onChange={formik.handleChange}
              value={formik.values.contactPersons[0].email}
              error={
                formik.errors.contactPersons?.[0]?.email
                  ? {
                      content: formik.errors.contactPersons[0].email,
                      pointing: "above",
                    }
                  : null
              }
            />
          </>
        )}

        <div className="formgroup">
          <Form.Group>
            <Button
              type="button"
              onClick={prevStep}
              color="orange"
              style={{ width: "33.3333%" }}
            >
              {t("common:actions.cancel")}
            </Button>
            <Button
              type="submit"
              primary
              style={{
                width: "33.3333%",
              }}
              loading={formik.isSubmitting}
            >
              {t("common:actions.register")}
            </Button>
          </Form.Group>
        </div>
      </Form>
    </>
  );
}
